<template>
    <div class="stationNotice">
        <div class="station_right">
            <div class="station_right_in">
                <h2 class="station_right_h2">埋数工具</h2>
                <div style="margin-bottom: 16px;">
                    <a-button type="primary" @click="showAddModal = true">新增</a-button>
                </div>
                    <a-table 
                        :columns="columns" 
                        :dataSource="taxNoList" 
                        row-key="id"
                        :pagination="{
                            current: pageNum,
                            pageSize: pageSize,
                            total: total,
                            onChange: handlePageChange
                        }"
                    >
                        <template slot="operation" slot-scope="text, record">
                            <a-button 
                                :disabled="record.orgNo=='-1'"
                                type="link" 
                                @click="handleCopy(record)"
                            >
                                复制
                            </a-button>
                        </template>
                    </a-table>
            </div>
        </div>

        <!-- 新增税号弹窗 -->
        <a-modal
            title="新增税号"
            v-model="showAddModal"
            @ok="handleAddOk"
            cancelText="取消"
            okText="确认"
        >
            <a-form layout="vertical">
                <a-form-item label="税号">
                    <a-input 
                        v-model="addForm.taxNo" 
                        placeholder="请输入税号"
                        required
                    />
                </a-form-item>
                <a-form-item label="企业名称">
                    <a-input 
                        v-model="addForm.corpName" 
                        placeholder="请输入企业名称"
                        required
                    />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 复制弹窗 -->
        <a-modal
            title="生成数据"
            v-model="showCopyModal"
            @ok="handleCopyOk"
            cancelText="取消"
            okText="确认"
        >
            <a-form layout="vertical">
                <a-form-item label="税号">
                    <a-input 
                        v-model="copyForm.targetTaxNo" 
                        placeholder="税号"
                        disabled
                    />
                </a-form-item>
                <a-form-item label="接口名称">
                    <a-select
                        v-model="copyForm.methodStr"
                        placeholder="请选择接口名称"
                        required
                    >
                        <a-select-option 
                            v-for="method in methodsList" 
                            :key="method.method"
                            :value="method.name+'-'+method.method"
                        >
                            {{ method.name }}-{{ method.method }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'invoiceCheck',
    data() {
        return {
            // 分页参数
            pageNum: 1,
            pageSize: 10,
            total: 0,
            // 税号列表数据
            taxNoList: [],
            // 方法列表
            methodsList: [],
            // 新增弹窗状态
            showAddModal: false,
            // 新增表单数据
            addForm: {
                taxNo: '',
                corpName: ''
            },
            // 复制弹窗状态
            showCopyModal: false,
            // 复制表单数据
            copyForm: {
                targetTaxNo: '',
                methodStr: ''
            }
        }
    },
    mounted() {
        this.getTaxNoList();
        this.getMethods();
    },
    methods: {
        // 获取税号列表
        getTaxNoList() {
            const params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum
            };
            this.http.post('/ystOpenPlatformBff/mock/getTaxNoList', params, res => {
                if (res.success) {
                    this.taxNoList = res.data.list || [];
                    this.total = res.data.total || 0;
                    this.pageNum = res.data.pageNum || 1;
                } else {
                    this.$message.error(res.message || '获取税号列表失败');
                }
            });
        },
        // 获取方法列表
        getMethods() {
            this.http.post('/ystOpenPlatformBff/mock/getMethods', {}, res => {
                if (res.success) {
                    this.methodsList = res.data || [];
                } else {
                    this.$message.error(res.message || '获取方法列表失败');
                }
            });
        },
        // 分页改变
        handlePageChange(pageNum) {
            this.pageNum = pageNum;
            this.getTaxNoList();
        },
        // 点击新增按钮打开弹窗
        handleAdd() {
            this.showAddModal = true;
            this.addForm = {
                taxNo: '',
                corpName: ''
            };
        },
        // 新增确认
        handleAddOk() {
            this.http.post('/ystOpenPlatformBff/mock/availableTaxNo', this.addForm, res => {
                if (res.success) {
                    this.$message.success('新增成功');
                    this.showAddModal = false;
                    this.getTaxNoList();
                } else {
                    this.$message.error(res.message || '新增失败');
                }
            });
        },
        // 点击复制按钮
        handleCopy(record) {
            this.showCopyModal = true;
            this.copyForm = {
                targetTaxNo: record.taxNo,
                methodStr: ''
            };
        },
        // 复制确认
        handleCopyOk() {
            if (!this.copyForm.methodStr) {
                this.$message.warning('请选择接口名称');
                return;
            }
            const [name, method] = this.copyForm.methodStr.split('-');
            this.http.post('/ystOpenPlatformBff/mock/copyData', {...this.copyForm, name, method}, res => {
                if (res.success) {
                    this.$message.success('生成数据成功');
                    this.showCopyModal = false;
                } else {
                    this.$message.error(res.message || '生成数据失败');
                }
            });
        }
    },
    computed: {
        // 表格列配置
        columns() {
            return [
                {
                    title: '企业名称',
                    dataIndex: 'corpName',
                    key: 'corpName'
                },
                {
                    title: '税号',
                    dataIndex: 'taxNo',
                    key: 'taxNo'
                },
                {
                    title: '更新时间',
                    dataIndex: 'updateTime',
                    key: 'updateTime'
                },
                {
                    title: '操作',
                    key: 'operation',
                    scopedSlots: { customRender: 'operation' }
                }
            ];
        }
    }
}
</script>

<style lang="scss">
ul.station_main {
    padding: 0;
    margin: 0;
    list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/_developCenter/MockTool.vue